<template>
  <div id="destination-order-list">
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="icon-area">
            <feather-icon class="mr-2" icon="FileTextIcon" svgClasses="h-7 w-7" />
          </div>
          <div class="title">入出港予定表</div>
        </div>
        <div class="menu-content">
          <div class="description">表示、編集する入出港予定表を選択してください。</div>
          <div class="order-list-area">
            <template v-if="orderList.length != 0">
              <div
                class="order-item"
                :class="{'draft-item': order.draft}"
                v-for="(order, index) in orderList"
                :key="index"
                @click="clickOrderItem(order.date, order.draft)"
              >
                <feather-icon class="mr-2 item-file-icon" icon="FileTextIcon" svgClasses="h-6 w-6" />
                <div class="date-text">
                  {{order.draft ? "作成中予定表" : displayDateText(order.date)}} <br>
                  {{order.draft ? "" : displayTimeRange}}
                </div>
                <div class="order-count-text">
                  オーダー件数：{{order.orderCount}}
                </div>
                <div v-if="!order.draft" class="download-area" @click.stop="callDownloadReport(order.date)">
                  <feather-icon class="mr-2" icon="DownloadIcon" svgClasses="h-6 w-6" />
                  <span>Excelファイル</span>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="order-item-empty order-item"
              >
                <div class="order-item-upper">
                  <feather-icon class="mr-2 item-file-icon" icon="FileTextIcon" svgClasses="h-6 w-6" />
                </div>
                <div class="empty-text">
                  入出港予定表がありません。ファイルを一括取込して新規に作成してください。
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="icon-area">
            <feather-icon class="mr-2" icon="DownloadIcon" svgClasses="h-7 w-7" />
          </div>
          <div class="title">入出港予定表作成</div>
        </div>
        <div class="menu-content">
          <div class="description">作成する予定表の日付を設定して、一括取込みのファイルを選択してください。</div>
          <div class="menu-button-area">
            <vs-button
              class="import-button"
              color="#2D9CDB"
              :to="{name: 'addon-port-master-destination-order-import'}"
            >
              <span class="import-button-inner">
                <feather-icon class="mr-2" icon="FilePlusIcon" svgClasses="h-5 w-5" />
              一括取込
              </span>
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import FileSaver from 'file-saver'
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit")
const { mapState: mapStateOfPortMaster, mapActions: mapActionsOfPortMaster } = createNamespacedHelpers("portMaster");

export default {
  data() {
    return {
      iconOffice: require("@/assets/images/icons/lolcal/corporate_fare.svg"),
      selectedControl: null,
      orderList: []
    }
  },
  async created() {
    this.$vs.loading()
    await this.fetchSettings(this.selectedPort);
    let orderList = await this.fetchOrderList(this.selectedPort)
    let orderDraftList = this.destinationWorkImportedTasksMap
    if (Object.keys(orderDraftList).length != 0) {
      orderDraftList = [
        {
          date: null,
          orderCount: Object.entries(orderDraftList).length,
          draft: true
        }
      ]
    } else {
      orderDraftList = []
    }
    this.orderList = orderDraftList.concat(orderList)

    this.$vs.loading.close()
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"
  },
  computed: {
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),  
    ...mapState({
      destinationWorkImportedTasksMap: state => state.destinationWorkImportedTasksMap,
      masterMap: state => state.masterMap
    }),
    hourIntervalNumber() {
      const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
      let hourIntervalString = hourIntervalObj ? hourIntervalObj.value : "00:00";
      let hourInterval = hourIntervalString.split(":")
      return Number(hourInterval[1]) != 0 ? Number(hourInterval[0]) + Number(hourInterval[1]) / 60 : Number(hourInterval[0])
    },
    displayTimeRange() {
      const hourIntervalObj = this.masterMap['tasks'].find(x => x.id === 'hour_interval');
      let hourIntervalString = hourIntervalObj ? hourIntervalObj.value : "00:00";
      let fromTime = moment("2000/01/01/" + hourIntervalString).format("hh:mm")
      let toTime = moment("2000/01/01/" + hourIntervalString).add(-1, "minutes").format("hh:mm")
      return `${fromTime} ~ 翌${toTime}`
    }
  },
  methods: {
    ...mapActions(["fetchOrderList","fetchSettings"]),
    ...mapActionsOfPortMaster(["downloadTasks"]),
    clickOrderItem(date, isDraft) {
      let jumpTo = isDraft ? "addon-port-master-destination-imported-work-edit" : "addon-port-master-destination-work-edit"
      this.$router.push(
        {
          name: jumpTo,
          params: { date: date }
        }
      )
    },
    filterOrderDraftList(draftList) {
      let dateArray = Object.keys(draftList)
      dateArray = dateArray.filter((date) => {
        return moment(date).isBefore(moment().format('YYYYMMDD'))
      })
      dateArray.forEach((date) => {
        delete draftList[date]
      })
      return draftList
    },
    displayDateText(date) {
      return date ? moment(date).format('YYYY/MM/DD') : null
    },
    dateChipText(date) {
      let today = moment(new Date()).format('YYYYMMDD')
      let tomorrow = moment(new Date()).add(1,'days').format('YYYYMMDD')
      let dayAfterTomorrow = moment(new Date()).add(2,'days').format('YYYYMMDD')
      if (date == today) {
        return '当日分'
      } else if (date == tomorrow) {
        return '翌日分'
      } else if (date == dayAfterTomorrow) {
        return '翌々日分'
      } else if (!date){
        return '作成中'
      } else {
        return null
      }
    },
    getMasterData() {
      // portOption取得
      this.fetchPorts()
      // rank取得
      this.fetchRanks()
      // display取得
      this.fetchDisplaySettings()
    },
    async callDownloadReport(date) {
      let payload = {
        portId: this.selectedPort.id,
        date: date
      }
      this.$vs.loading();
      try {
        let res = await this.downloadTasks(payload)
        const fileName = `予定表_${date}.xlsx`
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/port-master/_variables.scss";
.card {
  margin-top: 30px;
}
.menu-section {
  margin: 10px 0px;
}
.header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .icon-area {
    width: 36px;
  }
}
.menu-button-area {
  margin: 20px 0px;
}
.description {
  margin-bottom: 10px;
}
.menu-content {
  margin-left: 45px;
}
.title {
  font-weight: bold;
}
.order-list-area {
  display: flex;
  overflow-x: scroll;
}
.order-item {
  border: solid 1px $pm-blue;
  border-radius: 10px;
  padding: 20px 20px 30px 20px;
  margin-right: 15px;
  width: 165px;

  cursor: pointer;
  &-empty {
    cursor: default;
    background: $pm-paper-white;
    border-width: 0px;
    .empty-text {
      color: $pm-slightly-light-gray;
    }
    .item-file-icon {
      color: white;
    }
  }
}
.draft-item {
  background: $pm-white;
}
.order-item-upper {
  display: flex;
  margin-bottom: 15px;
  height: 21px;
}
.blue-chip-text {
  color: $pm-white;
  background: $pm-blue;
  padding: 0px 12px;
  border-radius: 12px;
  margin-left: auto;
}
.gray-chip-text {
  color: $pm-white;
  background: $pm-gray;
  padding: 0px 12px;
  border-radius: 12px;
  margin-left: auto;
}
.item-file-icon {
  color: $pm-blue;
  margin: 15px 0px;
}
.order-count-text {
  margin-top: 25px;
}
.download-area {
  display: flex;
  margin-top: 15px;
  &:hover {
    color: $pm-blue;
    transition: 0.2s;
  }
}
.date-text {
  text-align: left;
  font-weight: bold;
  font-size: 14px;
  height: 50px;
}
.import-button-inner {
  display: flex;
  align-items: center;
}
</style>
